import { classnames } from 'Utils/classnames/classnames.utils';

const small = {
  thTitle: 'font-bold font-sans text-12 text-black text-center w-full',
  thNrr: 'mb-10',
};

const medium = {
  thRoot: 'sm:flex sm:flex-wrap',
  thTitle: classnames(small.thTitle, 'px-10 pt-10 sm:flex-none'),
  thNrr: classnames(small.thNrr, 'sm:mb-0 sm:flex-1'),
  thStandard: classnames(small.thStandard, 'sm:flex-1'),
};

export const themes = {
  default: small,
  medium,
  large: {
    ...medium,
    thTitle: classnames(medium.thTitle, 'md:text-initial md:flex-1 md:p-20 md:pb-0'),
  },
};
